import { render, staticRenderFns } from "./NeoCarrusel.vue?vue&type=template&id=4dc74337&scoped=true&"
import script from "./NeoCarrusel.vue?vue&type=script&lang=js&"
export * from "./NeoCarrusel.vue?vue&type=script&lang=js&"
import style0 from "./NeoCarrusel.vue?vue&type=style&index=0&id=4dc74337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc74337",
  null
  
)

export default component.exports